<template>
  <footer>
    <div class="footer-container">
      <div class="container">
        <div class="row">
          <div class="row col-lg-12 footer">
            <div class="col-md-6">
              <div class="logo col-8">
                <img src="@/assets/images/logo.png" alt="" />
              </div>
              <ul class="footer-widget__list">
                <li >
                  <span class="footer-text">Atención al cliente SPARK81 - Barcelona: 
                    <br>
                  <a href="mailto:barcelona@spark81.com" class="hover-style-link"
                    >barcelona@spark81.com</a>
                    <br>
                    <a href="tel:644255104" class="hover-style-link">644255104</a>
                  </span>
                </li>
                <br>
                <li >
                  <span class="footer-text">Atención al cliente SPARK81 - A Coruña: 
                    <br>
                  <a href="mailto:info@spark81coruna.com" class="hover-style-link"
                    >info@spark81coruna.com</a>
                    <br>
                    <a href="tel:633586858" class="hover-style-link">633586858</a>
                  </span>
                </li>
                <br>
                
                <li >
                  <span class="footer-text">Atención al cliente SPARK81 - Terrassa:  
                    <br>
                  <a href="mailto:barcelona@thecityescaperoom.com" class="hover-style-link"
                    >barcelona@thecityescaperoom.com</a>
                    <br>
                    <a href="tel:682289441" class="hover-style-link">682289441</a>
                  </span>
                </li>
                <br>
                <li >
                  <span class="footer-text"> Contacto de empresa: 
                    <br>
                  <a href="mailto:hola@spark81.com" class="hover-style-link"
                    >hola@spark81.com</a>
                    <br>
                    <a href="tel:624329890" class="hover-style-link">624329890</a>
                  </span>
                </li>
                
              </ul>
            </div>

            
            <div class="col-md-6 footer-widget">
             
              <div class="row">
                <h6 class="footer-text">Nuestras redes</h6>
              </div>

              <div class="row">
                <a
                  href="https://www.instagram.com/playspark81"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-instagram social-link-icon"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@playspark81"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-tiktok social-link-icon"></i>
                </a>
                <!--
                  <a href="https://twitter.com/" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                  -->
              </div>
            
              <h6 class="footer-text">Enlaces</h6>
              <ul class="footer-widget__list">
                <li class="cursor-pointer">
                  <a
                  @click="
                        () => {
                          $router.push({ name: 'contact' });
                        }
                      "
                  class="hover-style-link">CONTACTO</a>
                </li>
                <li class="cursor-pointer">
                  <a
                  @click="
                        () => {
                          $router.push({ name: 'events' });
                        }
                      "
                  class="hover-style-link">EVENTOS</a>
                </li>
                <li class="cursor-pointer">
                  <a 
                  @click="
                        () => {
                          $router.push({ name: 'about' });
                        }
                      "
                  class="hover-style-link">CONÓCENOS</a>
                </li>
                <li class="cursor-pointer">
                  <a 
                  @click="
                        () => {
                          $router.push({ name: 'legal' });
                        }
                      "
                  class="hover-style-link">AVISO LEGAL</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p>Copyright © 2025 <a href="#">TEAMING LABS</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { onMounted, ref } from "vue";
// @ is an alias to /src
export default {
  name: "FooterComponent",
  components: {},
  setup(props) {
    return {};
  },
};
</script>
